import api from '@/services/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

const usePostEquipmentAssign = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationKey: ['postEquipmentAssign'],
    mutationFn: ({ data }: { data: any }) => {
      return api.equipments.postEquipmentAssign(data);
    },
    onError: (error) => {
      const errorMessage = error.message;
      toast.error(t('toast.error', { errorMessage }));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] === 'reservation' ||
          query.queryKey[0] === 'reservations'
      });
      toast.success(t('toast.reservationSuccess'));
    },
    retry: false
  });
};

export default usePostEquipmentAssign;
